module.exports = __webpack_public_path__ + "img/奖章5级@2x.c51a0333.png";